import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import Sidebar from '../components/Sidebar';
import { api } from '../utils/api';
import { useI18n } from '../i18n/I18nProvider';

const AccountPage = () => {
  const [profile, setProfile]   = useState({ name: '', email: '', phone: '' });
  const [profileMsg, setProfileMsg] = useState(null);

  const [pwdForm, setPwdForm]   = useState({ current: '', new: '', confirm: '' });
  const [pwdMsg, setPwdMsg]     = useState(null);

  const [loading, setLoading]   = useState(true);
  const { t } = useI18n();

  useEffect(() => {
    api.getAccount().then(r => r.ok ? r.json() : null).then(acc => {
      if (acc) setProfile({ name: acc.Name || '', email: acc.Email || '', phone: acc.Phone || '' });
      setLoading(false);
    });
  }, []);

  const handleProfileSave = async (e) => {
    e.preventDefault();
    setProfileMsg(null);
    const res = await api.updateAccount({ name: profile.name, email: profile.email, phone: profile.phone });
    if (res.ok) {
      setProfileMsg({ ok: true, text: t('account.saved') });
    } else {
      const d = await res.json().catch(() => ({}));
      setProfileMsg({ ok: false, text: d.error || t('account.failedToSave') });
    }
  };

  const handlePasswordSave = async (e) => {
    e.preventDefault();
    setPwdMsg(null);
    if (pwdForm.new !== pwdForm.confirm) {
      setPwdMsg({ ok: false, text: t('account.passwordsMismatch') });
      return;
    }
    const res = await api.changePassword(pwdForm.current, pwdForm.new);
    if (res.ok) {
      setPwdMsg({ ok: true, text: t('account.passwordChanged') });
      setPwdForm({ current: '', new: '', confirm: '' });
    } else {
      const d = await res.json().catch(() => ({}));
      setPwdMsg({ ok: false, text: d.error || t('account.failedToChangePassword') });
    }
  };

  const header = <h1 className="uh-title">{t('account.title')}</h1>;

  if (loading) return <Layout sidebar={<Sidebar />} header={header}><p className="uh-empty">{t('common.loading')}</p></Layout>;

  return (
    <Layout sidebar={<Sidebar />} header={header}>
      <div style={{ maxWidth: 520 }}>
        {/* Profile */}
        <div className="uh-card" style={{ padding: 24, marginBottom: 24 }}>
          <h2 style={{ margin: '0 0 20px', fontSize: 16 }}>{t('account.profile')}</h2>
          {profileMsg && (
            <div className={profileMsg.ok ? 'uh-alert-success' : 'uh-alert-error'}>{profileMsg.text}</div>
          )}
          <form onSubmit={handleProfileSave}>
            <div className="uh-form-group">
              <label className="uh-label">{t('auth.name')}</label>
              <input className="uh-input" value={profile.name}
                onChange={e => setProfile(p => ({ ...p, name: e.target.value }))} />
            </div>
            <div className="uh-form-group">
              <label className="uh-label">{t('auth.email')}</label>
              <input className="uh-input" type="email" value={profile.email}
                onChange={e => setProfile(p => ({ ...p, email: e.target.value }))} />
            </div>
            <div className="uh-form-group">
              <label className="uh-label">{t('account.phone')}</label>
              <input className="uh-input" type="tel" value={profile.phone}
                onChange={e => setProfile(p => ({ ...p, phone: e.target.value }))} />
            </div>
            <div className="uh-actions" style={{ justifyContent: 'flex-end' }}>
              <button type="submit" className="uh-btn uh-btn-primary">{t('common.save')}</button>
            </div>
          </form>
        </div>

        {/* Change password */}
        <div className="uh-card" style={{ padding: 24 }}>
          <h2 style={{ margin: '0 0 20px', fontSize: 16 }}>{t('account.changePassword')}</h2>
          {pwdMsg && (
            <div className={pwdMsg.ok ? 'uh-alert-success' : 'uh-alert-error'}>{pwdMsg.text}</div>
          )}
          <form onSubmit={handlePasswordSave}>
            <div className="uh-form-group">
              <label className="uh-label">{t('account.currentPassword')}</label>
              <input className="uh-input" type="password" value={pwdForm.current}
                onChange={e => setPwdForm(p => ({ ...p, current: e.target.value }))} required />
            </div>
            <div className="uh-form-group">
              <label className="uh-label">{t('account.newPassword')}</label>
              <input className="uh-input" type="password" value={pwdForm.new} minLength={8}
                onChange={e => setPwdForm(p => ({ ...p, new: e.target.value }))} required />
            </div>
            <div className="uh-form-group">
              <label className="uh-label">{t('account.confirmNewPassword')}</label>
              <input className="uh-input" type="password" value={pwdForm.confirm} minLength={8}
                onChange={e => setPwdForm(p => ({ ...p, confirm: e.target.value }))} required />
            </div>
            <div className="uh-actions" style={{ justifyContent: 'flex-end' }}>
              <button type="submit" className="uh-btn uh-btn-primary">{t('account.changePassword')}</button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default AccountPage;
